module.exports = __webpack_public_path__ + "img/brillante_10.7ce6073a.svg";